import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { IItem } from '@coreui/angular-pro'
import { RestService } from 'src/app/services/rest/rest.service';
import { GenericResponse, ReportTypes, HoldQueueResponse } from 'src/app/interfaces/apiresponses'; 
import { DatePipe } from '@angular/common';
import { TableUtil } from 'src/app/shared/utils/table.util';

@Component({
  selector: 'app-support-hold-que-audit-log',
  templateUrl: './support-hold-que-audit-log.component.html',
  styleUrls: ['./support-hold-que-audit-log.component.scss'],
  providers: [DatePipe]
})
export class SupportHoldQueAuditLogComponent implements OnInit{
  // Alert buttons
  bAlert = false
  alertHeaderText = ""
  alertBodyText = ""
  bShowSecondAlertButton = false
  alertSecondButtonText = ""
  alertCloseButtonText = "Close"
  alertBoxData: any

  reportTypes: any
  nItems: number = 10
  date = new Date();
  startDate = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
  endDate = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);

  columns = [
    {
      key: 'createdOn',
      label: 'Requested On',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'cif',
      label: 'CIF',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'makerEmail',
      label: 'Maker',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'checkerEmail',
      label: 'Checker',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'decisionOn',
      label: 'Decision On',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'isApproved',
      label: 'Is Approved',
      filter: true
    },
    {
      key: 'rejectionComment',
      label: 'Rejection Reason',
      filter: false
    },
       {
      key: 'isMiddlewareSuccess',
      label: 'Middleware Success',
      filter: true
    },
  ];

  reportData: IItem[] = []
  bShowDownloadButton: boolean = false
  selectedItems = [2, 3];
  
  getCreatedOnDisplayDate(item: any) {
    return this.datePipe.transform(item,"dd-MM-yyyy")
  }

  getDecisionOnDisplayDate(item: any) {
    if (item.checkerEmail == null) {
      return 'Pending'
    }

    return this.datePipe.transform(item.decisionOn,"dd-MM-yyyy")
  }

  getDateString(dateValue: Date){
    return this.datePipe.transform(dateValue,"yyyy-MM-dd")
  }

  // Search Form
  searchReportType: string = ''

  cifSearchForm = new FormGroup({
    searchReportTypeControl: new FormControl(this.searchReportType),
  })

  get searchReportTypeControl() {return this.cifSearchForm.get('searchReportTypeControl')}

  constructor(private restApi: RestService, private datePipe: DatePipe, private changeDetector: ChangeDetectorRef){

  }

  getReportTypes() {
    this.restApi.getReportTypes().subscribe({
      next: (v: ReportTypes) => {
        if (v.success){
          this.reportTypes = v.makerCheckerFunctions
        }
      },
      error: (e) => {

      }
    })
  }

  ngOnInit() {
    this.getReportTypes()
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  onSelectChange(){
    this.bShowDownloadButton = false
    this.reportData = []
  }

  onStartDateChane(item: any){
    this.bShowDownloadButton = false
    this.startDate = item
    this.reportData = []
  }

  onEndDateChane(item: any){
    this.bShowDownloadButton = false
    this.endDate = item
    this.reportData = []
  }

  getApprovalText(item: any){
    if (item.checkerEmail == null) {
      return 'Pending'
    }

    if (item.isApproved == true)
      return 'Yes'
    else
      return 'No'
  }

  getMiddlewareText(item: any){
    if (item.checkerEmail == null) {
      return 'Pending'
    }

    if (item.isMiddlewareSuccess == true)
      return 'Yes'
    else
      return 'No'
  }

  generateReport(){
    let startDateString = this.getDateString(this.startDate)
    let endDataString = this.getDateString(this.endDate)

    if (this.searchReportTypeControl?.value != null && startDateString != null && endDataString != null){

      this.restApi.getHoldQueueReport(this.searchReportTypeControl.value, startDateString, endDataString).subscribe({
        next: (v: HoldQueueResponse) => {
          if (v.success){
            this.bShowDownloadButton = true
            this.nItems = v.holdQueues.length
            this.reportData = v.holdQueues.map((item, Reference) => {
              const _selected = this.selectedItems.includes(Reference);
              return {
                ...item,
                _selected
              };
            })
          } else {

          }
        },
        error: (e) => {

        }
      })
    }
  }

  downloadReport(){
    if (TableUtil.exportArrayToExcel(this.reportData, 'HoldQueueAuditLog')) 
      this.showAlertBox('Downloaded', 'The report is downloaded. Please look for the report in your browser download section.')
    else
      this.showAlertBox('Sorry', 'Unable to download the report. Please contact technical support.')
  }

  closeAlert(event: any){

  }

  alertVisibility(event: any)
  {
    this.bAlert = event.state
  }

  showAlertBox(heading: string, body: string, closeButtonText: string = "Close", showSecondButton: boolean = false, secondButtonText: string = "Understood", data: any = {})
  {
    this.alertHeaderText = heading
    this.alertBodyText = body
    this.bShowSecondAlertButton = showSecondButton
    this.alertSecondButtonText = secondButtonText
    this.alertCloseButtonText = closeButtonText
    this.alertBoxData = data
    this.bAlert = true
  }

  onAlertButtonClick(event: any){
    this.bAlert = event.state
    if (event.data.action === 1){
    }
  }
}
